// extracted by mini-css-extract-plugin
export default {"container":"CommunityPatternsRoot_container__6da5k"};